// extracted by mini-css-extract-plugin
export var smallSpinner = "_rb-0";